export enum PermissionsIAM {
  usuarios = 13,
  grupos = 12,
  politicas = 16,
  roles = 14,
  permisos = 15,
  reset_mfa = 38000,
  editUsuarios = 96,
  creatGroup = 97,
  creatDeletePolitic = 98,
  editCreatRol = 99,
  creatEditPermission = 101,
  assignTerminal = 38001,
}
